import {register} from './../exports/theme-sections';
import parallaxImage from './../exports/parallaxImage';

register('blog', parallaxImage);
